import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const DEFAULT_MIME_TYPE = 'application/json';

const axiosS3Instance = axios.create({
  baseURL: process.env.GETSIGNED_URL_API,
  timeout: 30000,
  headers: {
    Accept: DEFAULT_MIME_TYPE
  }
});

// Add a request interceptor
axiosS3Instance.interceptors.request.use(requestInterceptor);

export default axiosS3Instance;



// WEBPACK FOOTER //
// ./src/common/api/s3Api.js